export const getAdsStepStyles = (/* components, theme */) => ({
  displayAdPanelRoot: {
    marginTop: 20,
    width: 500,
    minHeight: 181,
    padding: 20,
    paddingBottom: 20,
    paddingTop: 10,
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: 6,
    '& .image-list-item-status-indicator': {
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
      borderRadius: 6,
      width: '170px !important',
      height: '96px !important',
      paddingTop: '10px !important',
      '&:hover': {
        '& .edit-button': {
          display: 'none',
        },
      },
      '& .placeholder-content': {
        color: 'white !important',
      },
    },
    '& .error': {
      width: 400,
      marginTop: 20,
      float: 'left',
    },
    '& .image-experience-content': {
      width: 170,
      '& .col-sm-3': {
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
        borderRadius: 6,
        width: '170px !important',
        height: '96px !important',
        paddingTop: '10px !important',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        alignItems: 'center',
        '&:hover': {
          '& .edit-button': {
            display: 'none',
          },
        },
        '& .placeholder-content': {
          color: 'white !important',
        },
        '& .ms-Button': {
          width: 56,
          height: 24,
          marginTop: 10,
        },
      },
      '& .add-image-button': {
        border: '1px solid #8a8886',
        background: '#FFFFFF !important',
        fontWeight: 600,
        borderRadius: 2,
        '&:before': {
          content: '"\\E710"',
          color: '#0078D4',
          marginRight: 8,
          fontFamily: 'MsAds MDL2 Assets',
        },
      },
    },
    '& .image-section-label': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .image-list-label': {
      fontWeight: 600,
    },
    '& .image-list-content': {
      width: '170px !important', // fixed for 16:9 aspect ratio
      border: 'none !important',
      padding: '0px !important',
    },
    '& .image-list-item-video': {
      position: 'relative',
      backgroundColor: 'none !important',
      width: '170px !important', // fixed for 16:9 aspect ratio
      '&:hover': {
        '& .edit-button': {
          display: 'flex',
        },
      },
      '& .placeholder-content': {
        color: 'black !important',
      },

    },
    '& .image-item-ratio-label': {
      paddingTop: 10,
    },
    '& .thumbnail-preview': {
      borderRadius: 6,
      filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
      width: '170px !important',
      height: '96px !important',
    },
  },
  addNewImageButton: {
    height: 96,
    width: 170,
    borderRadius: '6px',
    border: '1px dashed #c8c6c4',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  selectedPanel: {
    border: '1px solid #0078D4',
  },
  displayAdPanelHeader: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    height: 5,
  },
  displayAdPanelButton: {
    justifyContent: 'flex-end',
    display: 'none',
    cursor: 'pointer',
    borderRadius: 99,
    background: '#FFFFFF',
    width: 32,
    height: 32,
  },
  displayAdPanelButtonContainer: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    columnGap: '2px',
    display: 'flex',
  },
  previewContainer: {
    height: 280,
    width: '100%',
  },
  emptyPreview: {
    width: '100%',
    height: '100%',
    backgroundColor: '#F3F2F1',
    borderRadius: 6,
  },
  adPreviewRoot: {
    maxWidth: '540px',
    width: '100%',
    padding: 20,
    paddingTop: 0,
    position: 'sticky',
    top: '-10px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: '-18px',
  },
  adPreviewSizeHeader: {
    height: 40,
  },
  adPreviewPageTitle: {
    fontSize: 14,
    fontWeight: 600,
  },
  adPreviewSizeTitle: {
    fontSize: 14,
    fontWeight: 700,
    paddingRight: 5,
  },
  adPreviewPanel: {
    maxWidth: '540px',
    width: '100%',
    padding: 20,
    position: 'sticky',
    top: '0px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: 16,
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: 6,
  },
  displayAd: {
    borderRadius: '6px',
    filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
  },
  previewTag: {
    marginTop: 20,
  },
  previewTagText: {
    fontSize: 12,
    color: '#605E5C',
  },
  pagination: {
    paddingTop: 20,
    width: '100%',
  },
  pageControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '10px',
  },
  pageControl: {
    display: 'flex',
    alignItems: 'center',
  },
  pageControlPreviousIcon: {
    paddingRight: 8,
  },
  pageControlNextIcon: {
    paddingLeft: 8,
  },
  paginationIndicatorDot: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    display: 'inline-block',
    cursor: 'pointer',
    marginRight: 10,
  },
  paginationButton: {
    height: 8,
    width: 8,
    opacity: 0,
  },
  paginationIndicator: {
    display: 'flex',
    columnGap: '2px',
  },
  displayAdPanelContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  placementInfoTile: {
    paddingTop: 20,
    marginLeft: 10,
  },
  placementInfos: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: 10,
    rowGap: '5px',
  },
  enabledPlacement: {
    backgroundColor: '#DFF6DD',
    padding: '3px 5px',
    borderRadius: 4,
  },
  enabledText: {
    color: '#0C5E0C',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    columnGap: 5,
  },
  disabledPlacement: {
    backgroundColor: '#F3F2F1',
    padding: '3px 5px',
    borderRadius: 4,
  },
  disabledText: {
    color: '#605E5C',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    columnGap: 5,
  },
  fontStyle: {
    fontSize: 14,
    fontWeight: 600,
  },
  placementLabel: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  placmentResolution: {
    paddingTop: 5,
    paddingBottom: 5,
  },
  displayAdPanelFinalUrlContainer: {
    width: 45,
  },
  displayImageLabel: {
    marginBottom: 4,
  },
});

export const getCreativeWorkbenchStyles = () => ({
  creativeWorkbenchRoot: {
    position: 'relative',
    display: 'flex',
    padding: '24px',
    height: 'auto',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '12px',
    marginTop: '16px',
    border: '1px dashed #B3B0AD',
  },
  header: {
    fontSize: 16,
    fontWeight: '600',
    lineHeight: '20px',
    display: 'flex',
  },
  copilotIcon: {
    paddingTop: '3px !important',
    paddingLeft: '0px !important',
    paddingRight: '9px !important',
    marginBottom: '2px',
    height: '21px',
  },
  description: {
    fontSize: 14,
    fontWeight: '400',
    color: 'rgba(96, 94, 92, 1)',
    lineHeight: '20px',
  },
});

export const getImageSuggestionCarouselStyles = () => ({
  imageSuggestionCarouselRoot: {
    '& .image-suggestion-carousel-root': {
      '& .panel': {
        backgroundColor: 'transparent',
      },
    },
    marginTop: 10,
  },
  croppedImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '107px',
    height: '76px',
    background: '#F3F2F1',
  },
});

export const getDisplayAdStepBaseStyles = () => ({
  displayAdsStepRoot: {
    '& .display-ad-panel-root': {
      width: '100% !important',
    },
  },
});
